import Chip from '@components/Chip';
import Column from '@components/Column';
import PrepaidContext from '@components/prepaid/PrepaidProvider/PrepaidContext';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useContext, useEffect, useState } from 'react';

import styles from './styles.module.scss';

const examples: number[] = [1, 2, 3, 5];

interface Props {
    initialAmount?: number;
}

function PrepaidCardAmount({ initialAmount }:Props) {
  const [isManual, setIsManual] = useState<boolean>(false);
  const { amount, setAmount } = useContext(PrepaidContext);
  useEffect(() => {
    if (initialAmount) {
      setAmount(initialAmount / 10000);
    }
  }, [initialAmount]);
  return (
        <Column fullWidth
                className={styles.container}>
            <Text size='2xl'
                  fontWeight='bold'
                  color={colors.gray7}>
                충전 금액
            </Text>
            <AmountList>
                {examples.map((value) => (
                    <Chip key={`amount ${value}`}
                                isSelected={amount === value && !isManual}
                                onClick={() => {
                                  setAmount(value);
                                  setIsManual(false);
                                }} >
                        {value}만원
                    </Chip>
                ))}
                <Chip isSelected={isManual}
                            onClick={() => setIsManual(true)} >
                    직접 입력
                </Chip>
            </AmountList>
            {isManual && (
                <Column fullWidth spacing={10} className={styles.manual}>
                    <Row fullWidth spacing={12}>
                        <TextField placeholder='정확한 금액을 숫자로 입력해주세요.'
                                   value={amount.toString()}
                                   onChange={(e) => setAmount(Number(e.target.value))}
                                   max={50}
                                   min={1}
                                   // @ts-ignore
                                   type='number'
                                   inputMode='numeric' />
                        <Text size='xl' fontWeight='bold' color={colors.gray7}>
                            만원
                        </Text>
                    </Row>
                    <Text size='s' fontWeight='bold' color={colors.gray5}>
                        1만원 단위로 최대 50만원까지 충전이 가능합니다.
                    </Text>
                </Column>
            )}
        </Column>
  );
}

const AmountList = styled(Chip.Container)`
    margin-top: 24px;
`;

export default PrepaidCardAmount;
